import React from "react";
import MultiEditor from "./MultiEditor";
import { observer } from "mobx-react";

const IsdEditable = observer(({
    row,
    cell,
    column: { id },
    columns,
    updateMyEdits
}) => {
    // We need to keep and update the state of the cell normally
    const [value, setValue] = React.useState(row.original[id]);
    const onChange = (e) => {
        setValue(e.target.value);
        updateMyEdits(row.index, id, e.target.value);
    };
    let cellIndex = 0;
    for (let i = 0; i < columns.length; i++) {
        if (id === columns[i].id) {
            cellIndex = i;
            break;
        }
    }
    React.useEffect(() => {
        setValue(row.original[id]);
    }, [row.original[id]]);

    return <MultiEditor editor={cell.column.editor}
        rows={{ row: row.index, cell: cellIndex }}
        value={value} name={id} data={row.original}
        onChange={onChange} row={row} cell={cell} updateMyEdits={updateMyEdits}
    />;
});

export default IsdEditable;